export const imageElementFromBase64Jpeg = (base64: string | null): Promise<HTMLImageElement | null> => {
    return new Promise<HTMLImageElement | null>((resolve, reject) => {
        if (!base64) {
            resolve(null);
            return;
        }

        const img = document.createElement('img');
        img.onload = () => {
            resolve(img);
        };
        img.onerror = () => {
            reject(new Error('341'));
        };
        img.src = `data:image/jpeg;base64,${base64}`;
    });
};



// WEBPACK FOOTER //
// ./src/ui/shared/imageElementFromBase64Jpeg.ts